export interface entryModel {
    id: string;
    values: {
        comment: string;
        username: string;
        time_entry_in_seconds: number;
        timestamp: string
    }
}

export interface TimeTrackModel {
    total_time_entries_hours: number;
    total_time_entries_minutes: number;
    total_time_in_minutes: number;
    total_time_entries_text: string;
    entries: entryModel[]
}

export interface TimeTrackComment {
    id: string;
    comment: string;
    username: string;
    timeStamp: Date
}

export interface TimeTrackPayload {
    email: string;
    hours: number;
    minutes: number;
    date: string;
}

export class ReportTimeTrack {
    static create (model: TimeTrackModel): ReportTimeTrack {
        const {
            total_time_entries_hours: totalTimeEntriesHours,
            total_time_entries_minutes: totalTimeEntriesMinutes,
            total_time_entries_text: totalTimeEntriesText,
            entries
        } = model;

        const comments = entries.map((entry) => {
            const {
                id,
                values: {
                    comment,
                    username,
                    timestamp: serializedTimeStamp
                }
            } = entry;

            const timeStamp = new Date(serializedTimeStamp);
            return {
                id,
                comment,
                username,
                timeStamp
            };
        });

        
        return new ReportTimeTrack(
            totalTimeEntriesHours,
            totalTimeEntriesMinutes,
            totalTimeEntriesText,
            comments
        );
    }
    constructor(
        public readonly totalTimeEntriesHours: number,
        public readonly totalTimeEntriesMinutes: number,
        public readonly totalTimeEntriesText: string,
        public readonly comments: TimeTrackComment[]
    ){}
}